/* registericons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon("siteexplorer.add_site", require("./rawicons/add_site.icon.svg"));
IconRegistry.registerIcon("siteexplorer.globe", require("./rawicons/globe.icon.svg"));
IconRegistry.registerIcon(
    "siteexplorer.site_details",
    require("./rawicons/site_details.icon.svg.js")
);
IconRegistry.registerIcon(
    "siteexplorer.site_explorer",
    require("./rawicons/site_explorer.icon.svg.js")
);
// IconRegistry.registerIcon("siteexplorer.siteview", require("./rawicons/site.icon.svg.js"));

IconRegistry.registerIcon("siteexplorer.data_center", require("./rawicons/datacenter.icon.svg"));
IconRegistry.registerIcon("siteexplorer.campus", require("./rawicons/campus.icon.svg"));
IconRegistry.registerIcon("siteexplorer.building", require("./rawicons/building.icon.svg"));
IconRegistry.registerIcon("siteexplorer.colo", require("./rawicons/colo.icon.svg")); //
IconRegistry.registerIcon("siteexplorer.csp", require("./rawicons/csp.icon.svg"));
IconRegistry.registerIcon("siteexplorer.kiosk", require("./rawicons/kiosk.icon.svg"));
IconRegistry.registerIcon("siteexplorer.home", require("./rawicons/home.icon.svg"));
IconRegistry.registerIcon("siteexplorer.warehouse", require("./rawicons/warehouse.icon.svg"));
IconRegistry.registerIcon("siteexplorer.store", require("./rawicons/store.icon.svg"));
IconRegistry.registerIcon("siteexplorer.plant", require("./rawicons/plant.icon.svg"));
IconRegistry.registerIcon("siteexplorer.branch", require("./rawicons/branch.icon.svg"));
IconRegistry.registerIcon("siteexplorer.internet", require("./rawicons/internet.icon.svg"));
IconRegistry.registerIcon("siteexplorer.site", require("./rawicons/site.icon.svg"));
IconRegistry.registerIcon(
    "siteexplorer.administration",
    require("./rawicons/administration.icon.svg.js")
);
IconRegistry.registerIcon("siteexplorer.hospital", require("./rawicons/hospital.icon.svg.js"));
IconRegistry.registerIcon("siteexplorer.mob", require("./rawicons/mob.icon.svg.js"));

IconRegistry.registerIcon("site.auto_assign", require("./rawicons/rotate_auto.icon.svg.js"));
